// Invoice Management Permissions

// Sales Invoices
export const SALES_INVOICES_INDEX = 1;
export const SALES_INVOICES_SHOW = SALES_INVOICES_INDEX;
export const SALES_INVOICES_CREATE = 2;
export const SALES_INVOICES_PRINT = 1299;
// Producing the document is one capability: download is gated by the print permission.
export const SALES_INVOICES_DOWNLOAD = SALES_INVOICES_PRINT;

// Purchase Invoices
export const PURCHASE_INVOICES_INDEX = 5;
export const PURCHASE_INVOICES_CREATE = 6;
export const PURCHASE_INVOICES_PRINT = 1300;
export const PURCHASE_INVOICES_DOWNLOAD = PURCHASE_INVOICES_PRINT;

// Request Purchase Order
export const RPO_INDEX = 108;
export const RPO_CREATE = 109;

// Purchase Order — the step between a purchase request and a purchase invoice.
// Ids are the central key service's approval numbers, minted by
// amer-laravel's 2026_07_29_000002_add_purchase_order_permissions migration.
export const PO_INDEX = 1424;
export const PO_CREATE = 1425;

// Reading a balance follows the invoice list it is read from.
export const SALES_INVOICE_BALANCE_VIEW = SALES_INVOICES_INDEX;
export const SALES_INVOICE_BALANCE_PAY = 288;

export const PURCHASE_INVOICE_BALANCE_VIEW = PURCHASE_INVOICES_INDEX;
export const PURCHASE_INVOICE_BALANCE_PAY = 289;

export const COLLECT_CUSTOMER_DUES = 283;
export const COLLECT_OWNER_DUES = 285;

export const CREDIT_NOTE_INDEX = 318;
// The credit-note detail endpoint gates on the list permission; there is no separate show key.
export const CREDIT_NOTE_SHOW = CREDIT_NOTE_INDEX;
export const CREDIT_NOTE_CREATE = 319;
export const CREDIT_NOTE_PRINT = 1303;
export const CREDIT_NOTE_DOWNLOAD = CREDIT_NOTE_PRINT;

export const DEBIT_NOTE_INDEX = 320;
export const DEBIT_NOTE_SHOW = DEBIT_NOTE_INDEX;
export const DEBIT_NOTE_CREATE = 321;
export const DEBIT_NOTE_PRINT = 1304;
export const DEBIT_NOTE_DOWNLOAD = DEBIT_NOTE_PRINT;
